export default "__VITE_ASSET__B01r_rP0__"